export const GradientSeparator = () => {
  return (
    <div className='self-stretch h-px opacity-25 bg-[radial-gradient(ellipse_50.00%_50.00%_at_50.00%_50.00%,_#0C3A78_0%,_rgba(24.63,_64.96,_118.73,_0)_100%)]' />
  )
}
